import React from 'react';
import { Modifier, EditorState } from 'draft-js';
import { Tooltip } from 'antd';

import { getRegxDataByTwoFacotor } from '@laigu/utils';

import TagComponent from './component';
import useConfig from '../../hooks/index';

const insertTag = (editor, editorState, data) => {
  const { label, text } = data;

  const contentState = editorState.getCurrentContent();

  const contentStateWithEntity = contentState.createEntity('REPLACE_WORD', 'IMMUTABLE', { selectType: label, text });
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  const currentSelectionState = editorState.getSelection();
  let addedContent;
  let emojiEndPos = 0;
  let blockSize = 0;
  const afterRemovalContentState = Modifier.removeRange(contentState, currentSelectionState, 'backward');

  const targetSelection = afterRemovalContentState.getSelectionAfter();
  addedContent = Modifier.insertText(
    afterRemovalContentState,
    targetSelection,
    `{{replace.${label}|'${text}'}}`,
    null,
    entityKey
  );

  emojiEndPos = targetSelection.getAnchorOffset();
  const blockKey = targetSelection.getAnchorKey();
  blockSize = contentState.getBlockForKey(blockKey).getLength();

  if (emojiEndPos === blockSize) {
    addedContent = Modifier.insertText(addedContent, addedContent.getSelectionAfter(), ' ');
  }

  const newState = EditorState.push(editorState, addedContent, 'insert-fragment');
  editor.setValue(newState);
};

const EntityComponent = props => {
  const { replaceKeywordOptions } = useConfig();
  const { offsetKey, decoratedText } = props;
  const { selectType, text } = getRegxDataByTwoFacotor(decoratedText);
  const allOptions = replaceKeywordOptions?.all || [];
  const showLabel = allOptions.find(val => val.value === selectType)?.label || selectType;

  return (
    <var className="replace-word-box">
      <Tooltip placement="top" title={<span>{`${showLabel}： ${text}`}</span>}>
        <span className="content" data-offset-key={offsetKey}>
          <span className="text">{showLabel}</span>
          <span>&nbsp;</span>
        </span>
      </Tooltip>
    </var>
  );
};

export default options => {
  options = {
    ...options
  };
  const { includeEditors } = options;
  return {
    key: 'replace_word',
    type: 'entity',
    name: 'REPLACE_WORD',
    // https://github.com/margox/braft-editor/issues/708
    // 有这个属性不会执行importer和exporter
    includeEditors,
    control: props => {
      const keywordOptions = props?.editor?.props?.keywordOptions;
      let keywords = [];
      if (keywordOptions) {
        keywords = [
          {
            label: '访问信息',
            options: keywordOptions.visit
          },
          {
            label: '系统字段',
            options: keywordOptions.main
          },
          {
            label: '顾客自定义',
            options: keywordOptions.custom
          }
        ];
      }
      return {
        key: 'REPLACE_WORD',
        type: 'component',
        component: (
          <TagComponent
            parentPrpos={props}
            options={keywords}
            insert={data => {
              insertTag(props.editor, props.editorState, data);
            }}
          />
        )
      };
    },
    mutability: 'IMMUTABLE',
    component: EntityComponent,
    importer: (nodeName, node) => {
      if (nodeName.toLowerCase() === 'var') {
        const content = node.innerText;
        const { selectType, text } = getRegxDataByTwoFacotor(content);
        if (selectType && text) {
          return {
            mutability: 'IMMUTABLE',
            data: { selectType, text }
          };
        }
      }
      return null;
    },
    exporter: entityObject => {
      const { selectType, text } = entityObject.data;
      return `<var>{{replace.${selectType}|'${text}'}}</var>`;
    }
  };
};
